// Longer than the default toast duration so users have time to read the
// message and click the action button.
const TOAST_DURATION_MS = {
  wrongMethod: 10000,
  suspended: 15000,
} as const;

export { TOAST_DURATION_MS };
